

export function createSearchParamsFrom(filter) {
    const params = new URLSearchParams();
    const filterKeys = Object.keys(filter).filter(filterItemKey => {
        if(Array.isArray(filter[filterItemKey])) {
            return filter[filterItemKey].length > 0;
        } else {
            return filter[filterItemKey] !== 0 && filter[filterItemKey] !== "0" && filterItemKey !== 'offset';
        }
    });
    filterKeys.forEach((key) => {
        const castValue = Array.isArray(filter[key]) ? filter[key].join(',') : filter[key];
        params.set(key, castValue);
    });

    return params.toString();
}

export function getParamFromUrl(queryParam, defaultValue = 0) {
    const queryParams = new URLSearchParams(window.location.search);

    return queryParams.has(queryParam) ? queryParams.get(queryParam) : defaultValue
}

export function updateUrl(filter) {
    const searchParams = createSearchParamsFrom(filter);

    const newURL = new URL(window.location.href);
    newURL.search = '?' + searchParams;
    window.history.pushState({ path: newURL.href }, '', newURL.href);
}


// WEBPACK FOOTER //
// ./src/services/frontendRouter.js